
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panduan-konsumen/my-home-credit-app",
      function () {
        return require("private-next-pages/panduan-konsumen/my-home-credit-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panduan-konsumen/my-home-credit-app"])
      });
    }
  